<div class="table-responsive" *ngIf="popoverInfo?.popoverItems">
  <table class="table table-borderless">
    <tbody>
      <tr *ngFor="let item of popoverInfo?.popoverItems; last as isLast">
        <td>
          <p>{{ getTranslationKey(item.name) | msg | async }}</p>
        </td>
        <td>
          <div *ngFor="let value of item.values">
            <small>- {{ getTranslationKey(value) | msg | async }}</small>
            <br />
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div *ngIf="popoverInfo?.contentText" class="text-center">
  <p>{{ getTranslationKey(popoverInfo!.contentText!) | msg | async }}</p>
</div>
